import { Upstream } from '@/infrastructure/network/Upstream/schema'
import { APIRequest } from '@/infrastructure/network/APIRequest'
import { HTTPMethod } from '@/infrastructure/network/types'
import { IQueryProps } from '@/entities/Upstream/Query'

export class GetMedia implements APIRequest<Upstream.Media.GetMediaResponse> {
  response: Upstream.Media.GetMediaResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  constructor(id: string) {
    this.path = `/media/${id}`
  }
}

export class FetchMedia implements APIRequest<Upstream.Media.FetchMediaResponse> {
  response: Upstream.Media.FetchMediaResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  params?: IQueryProps
  constructor(query?: IQueryProps) {
    this.params = query
    this.path = `/media`
  }
}
